import React from 'react';

const AllApplicationLoading = () => {
    return (
        <div className='grid grid-cols-4 place-items-center gap-5 mt-5 mx-5'>
        {Array.from({ length: 18 }).map((_, index) => (
          <div className="w-full h-[220px] animate-pulse rounded-xl bg-gray-100 p-4" key={index}>
            <div className='w-full h-[28px] animate-pulse rounded bg-gray-200 my-4'></div>
            <div className='w-full h-[28px] animate-pulse rounded bg-gray-200 mt-10'></div>
            <div className='w-full h-[28px] animate-pulse rounded bg-gray-200 my-2'></div>
            <div className='w-full h-[28px] animate-pulse rounded bg-gray-200 my-2'></div>
          </div>
        ))}
      </div>
    );
};

export default AllApplicationLoading;